var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path8, _path9, _path0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHackettCustomContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1500,
    height: 1500,
    viewBox: "0 0 1500 1500",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.28,1049.06c-23.58,0-41.51,18.87-41.51,41.51s18.87,41.51,41.51,41.51,41.51-18.87,41.51-41.51-18.87-41.51-41.51-41.51ZM245.28,1114.15c-12.26,0-22.64-10.38-22.64-22.64,0-13.21,10.38-22.64,22.64-22.64s22.64,10.38,22.64,22.64-10.38,22.64-22.64,22.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.38,1049.06c-23.58,0-41.51,18.87-41.51,41.51s18.87,41.51,41.51,41.51,41.51-18.87,41.51-41.51-17.92-41.51-41.51-41.51ZM360.38,1114.15c-12.26,0-22.64-10.38-22.64-22.64,0-13.21,10.38-22.64,22.64-22.64s22.64,10.38,22.64,22.64-9.43,22.64-22.64,22.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M476.42,1049.06c-23.58,0-41.51,18.87-41.51,41.51s18.87,41.51,41.51,41.51,41.51-18.87,41.51-41.51-18.87-41.51-41.51-41.51ZM476.42,1114.15c-12.26,0-22.64-10.38-22.64-22.64,0-13.21,10.38-22.64,22.64-22.64s22.64,10.38,22.64,22.64-10.38,22.64-22.64,22.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1350,396.23c0-26.42-21.7-48.11-48.11-48.11h-141.51v-191.51c0-5.66-3.77-9.43-9.43-9.43H349.06c-5.66,0-9.43,3.77-9.43,9.43v191.51h-141.51c-26.42,0-48.11,21.7-48.11,48.11v744.34c0,29.25,23.58,52.83,52.83,52.83h383.96v140.57h-80.19v18.87h484.91v-18.87h-86.79v-140.57h392.45c29.25,0,52.83-23.58,52.83-52.83V396.23ZM606.6,1333.96v-140.57h280.19v140.57h-280.19ZM358.49,287.74h783.02v720.75H358.49V287.74ZM1300.94,366.98c16.04,0,29.25,13.21,29.25,29.25v612.26h-170.75V366.98s141.51,0,141.51,0ZM358.49,166.04h783.02v102.83H358.49v-102.83ZM198.11,366.98h141.51v641.51h-170.75V396.23c0-16.04,13.21-29.25,29.25-29.25ZM1297.17,1174.53H202.83c-18.87,0-33.96-15.09-33.96-33.96v-113.21h1161.32v113.21c.94,18.87-15.09,33.96-33.02,33.96Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.98,351.89h-334.91c-5.66,0-9.43,3.77-9.43,9.43v139.62c0,5.66,3.77,9.43,9.43,9.43h334.91c5.66,0,9.43-3.77,9.43-9.43v-139.62c0-4.72-4.72-9.43-9.43-9.43ZM1057.55,491.51h-316.04v-120.75h316.04v120.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.98,546.23h-334.91c-5.66,0-9.43,3.77-9.43,9.43v139.62c0,5.66,3.77,9.43,9.43,9.43h334.91c5.66,0,9.43-3.77,9.43-9.43v-139.62c0-4.72-4.72-9.43-9.43-9.43ZM741.51,685.85v-120.75h316.04v120.75h-316.04Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 732.08,
    y: 766.04,
    width: 334.91,
    height: 18.87
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 732.08,
    y: 847.17,
    width: 334.91,
    height: 18.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 732.08,
    y: 927.36,
    width: 334.91,
    height: 18.87
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M659.43,351.89h-226.42c-5.66,0-9.43,3.77-9.43,9.43,4.72,588.68-9.43,584.91,9.43,584.91h226.42c5.66,0,9.43-3.77,9.43-9.43V361.32c0-4.72-4.72-9.43-9.43-9.43ZM650,927.36h-207.55V370.75h207.55v556.6Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 423.58,
    width: 140.57,
    height: 18.87
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 496.23,
    width: 140.57,
    height: 18.87
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 567.92,
    width: 140.57,
    height: 18.87
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 639.62,
    width: 140.57,
    height: 18.87
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 711.32,
    width: 140.57,
    height: 18.87
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 783.96,
    width: 140.57,
    height: 18.87
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 475.47,
    y: 855.66,
    width: 140.57,
    height: 18.87
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M452.83,179.25c-20.75,0-37.74,16.98-37.74,37.74s16.98,37.74,37.74,37.74,37.74-16.98,37.74-37.74-16.98-37.74-37.74-37.74ZM452.83,235.85c-10.38,0-18.87-8.49-18.87-18.87s8.49-18.87,18.87-18.87,18.87,8.49,18.87,18.87-8.49,18.87-18.87,18.87Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M565.09,179.25c-20.75,0-37.74,16.98-37.74,37.74s16.98,37.74,37.74,37.74,37.74-16.98,37.74-37.74-16.98-37.74-37.74-37.74ZM565.09,235.85c-10.38,0-18.87-8.49-18.87-18.87s8.49-18.87,18.87-18.87,18.87,8.49,18.87,18.87-8.49,18.87-18.87,18.87Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M676.42,179.25c-20.75,0-37.74,16.98-37.74,37.74s16.98,37.74,37.74,37.74,37.74-16.98,37.74-37.74-16.04-37.74-37.74-37.74ZM676.42,235.85c-10.38,0-18.87-8.49-18.87-18.87s8.49-18.87,18.87-18.87,18.87,8.49,18.87,18.87-7.55,18.87-18.87,18.87Z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 763.21,
    y: 207.55,
    width: 312.26,
    height: 18.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackettCustomContentIcon);
export default __webpack_public_path__ + "static/media/hackett-custom-content-icon.95831efea2136458474e820b1fc75a04.svg";
export { ForwardRef as ReactComponent };